const options = {
  displayLabelsTitle: true,
  mainPicture: 'ProductPictures',
  secondaryPicture: 'BrandPicture',
};

export default options;
